<template>
    <div class="footer">
        <a href="https://github.com/Carnaux/NFT-Marker-Creator"><img v-tooltip="'Github'" src="github.svg" class="iconSize"></a>
        <a href="https://github.com/webarkit"><img v-tooltip="'WebAR Kit'" src="webAr.png" class="iconSize border"></a>
        <!-- <a v-tooltip="'Github'" class="obs">Observations</a> -->
    </div>
</template>
<script>
import "../assets/TooltipStyleFooter.css";

export default {
    name: "Footer"
}
</script>
<style scoped>
a:hover{
    opacity: 0.75;
    cursor: pointer;
}
.footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 50px;
}
.iconSize{
    margin: 5px;
    width: auto;
    height: 40px;
}
.border{
    border-radius: 5px;
}
.obs{
    font-weight: bolder;
    position: relative;
    top: -20px;
}
.obs:hover{
    cursor: default;
}
</style>